import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StateService } from '@uirouter/angular';
import { GfTitleService } from '../../../../services/core.title.service';
import { SnapshotService } from '../../../../services/core.snapshot.service';
import { UiService } from '../../../../services/core.ui.service';
import { ProjectAdminSnapshotDeleteModalComponent } from './project.admin.snapshot.delete.modal'

@Component({
  selector: 'project-admin-snapshots',
  template: require('./project.admin.snapshots.html')
})
export class ProjectAdminSnapshotsComponent implements OnInit {
  @Input() project: any;
  @Input() isProjectAdmin: any;

  snapshots: any = false;
  snapshotRequest: any = false;
  submitting = false;
  deleting = false;
  deleteSnapshot: any;

  constructor(
    private stateService: StateService,
    private titleService: GfTitleService,
    private snapshotService: SnapshotService,
    private uiService: UiService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.project.name, 'Admin', 'Snapshots');
    this.doRefresh();
  }

  doRefresh(): void {
    this.snapshots = false;
    const params = this.stateService.params;
    this.snapshotService.listAll(params).then(response => {
      this.snapshots = _.get(response, 'items', []);
    });
    this.snapshotService.hasRequest(this.stateService.params.unixName).then(response => {
      this.snapshotRequest = _.get(response, 'data', false);
    });
  }

  submitRequest(repo: string = "N"): void {
    this.submitting = true;
    this.snapshotService.submitRequest(this.stateService.params.unixName, { exportRepo: repo }).then(
      result => {
        this.snapshotRequest = true;
        this.uiService.message.showSuccess('A snapshot has been requested for ' + this.project.name);
      },
      result => {
        const msg = _.get(result, 'message', 'An error occurred.');
        this.uiService.message.showWarning('Sorry, could not request a snapshot for ' + this.project.name + ': ' + msg);
      }
    ).finally(() => {
      this.submitting = false;
    });
  }

  cancelRequest(): void {
    this.submitting = true;
    this.snapshotService.deleteRequest(this.stateService.params.unixName).then(
      result => {
        this.snapshotRequest = false;
        this.uiService.message.showSuccess('Cancelled the snapshot request for ' + this.project.name);
      },
      result => {
        const msg = _.get(result, 'message', 'An error occurred.');
        this.uiService.message.showWarning('Sorry, could not cancel the snapshot request for ' + this.project.name + ': ' + msg);
      }
    ).finally(() => {
      this.submitting = false;
    });
  }

  openDeleteSnapshotModal(snapshot: any): void {
    const modalRef = this.modalService.open(ProjectAdminSnapshotDeleteModalComponent);
    // The modal declares @Input() snapshotId and deletes by it; it was previously handed a
    // `snapshot` property it does not have, so snapshotId stayed undefined and the delete
    // call went out with no id.
    modalRef.componentInstance.snapshotId = snapshot.id;

    modalRef.componentInstance.onClose.subscribe(() => {
        modalRef.close();
    });
  }

}
